import { TableColumn } from '@/components/elements/Table';
import Typography from '@/components/elements/Typography';
import { HTMLAttributes } from 'react';

export type TableHeadProps<TableRowData extends Record<string, unknown>> = {
  columns: TableColumn<TableRowData>[];
} & HTMLAttributes<HTMLElement>;

/**
 * @component TableHead
 */
function TableHead<TableRowData extends Record<string, unknown>>({
  columns,
  ...rest
}: TableHeadProps<TableRowData>) {
  return (
    <thead data-testid="table-head" {...rest}>
      <tr>
        {columns.map((head) => (
          <Typography
            data-testid="table-head_cell"
            key={head.field as string}
            as="th"
            variant="bodyLight"
            className="border-b text-left p-2 text-gray-500"
          >
            {typeof head.renderHeadCell === `function`
              ? head.renderHeadCell({ field: head.field, title: head.title })
              : head.title}
          </Typography>
        ))}
      </tr>
    </thead>
  );
}

export default TableHead;
